<template>
  <el-card shadow="hover" class="pointer">
    <el-row>
      <el-col :span="6">
        <el-image class="picture" :src="formatUrl(imgsrc)"></el-image>
      </el-col>
      <el-col :span="18" style="padding:0 60px">
        <span class="title font-shadow">{{title}}</span>
        <div class="font-overflow-2 " style="font-size: large;margin-top: 30px;line-height:50px" v-html="delHtmlTag(content)"></div>
        <div>
          <span style="color: #e6a23c" class="el-icon-s-flag flag"></span>
          <el-tag style="margin-right: 5px" type="warning" v-for="tag in date.split(',')" :key="tag">{{tag}}</el-tag>
          <el-button type="text" class="float-r" style="margin-top: 30px;font-size: medium">查看详情</el-button>
        </div>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: ""
      },
      imgsrc: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: ""
      },
      date: {
        type: String,
        default: ""
      }
    },
    methods:{
      delHtmlTag(str){
        return str.replace(/<[^>]+>/g,"");  //正则去掉所有的html标记
      }
    }
  };
</script>
<style scoped>
  .picture {
    padding: 10px;
    height: 300px;
    width: 500px;
    border-radius: 5px
  }

  .title {
    margin-top: 20px;
    text-align: center;
    display: block;
    font-weight: bold;
    font-size: x-large;
  }

  .flag {
    font-size: medium;
    color: #666;
    margin-top: 30px
  }
</style>



// WEBPACK FOOTER //
// src/components/sui-info/sui-info.vue